import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getSlideOptions: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide-option/list/`,
  },
  voteIdea: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide-option/{slideOptionId}/vote`,
  },
  unvoteIdea: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide-option/{slideOptionId}/unvote`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getSlideOptions = async (query) => {
  const res = await resource.getSlideOptions(query)
  return res.body
}

const voteIdea = async (slideOptionId, payload) => {
  const res = await resource.voteIdea({ slideOptionId }, payload)
  return res.body
}

const unvoteIdea = async (slideOptionId, payload) => {
  const res = await resource.unvoteIdea({ slideOptionId }, payload)
  return res.body
}

export default {
  initResource,
  getSlideOptions,
  voteIdea,
  unvoteIdea,
}
